import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { Link, type LinkProps } from "react-router";
import { Icon, type IconName } from "./Icon";

type Variant = "primary" | "secondary" | "ghost" | "danger" | "link";
type Size = "md" | "sm" | "lg";

interface Common {
  variant?: Variant;
  size?: Size;
  icon?: IconName;
  iconEnd?: IconName;
  busy?: boolean;
  children?: ReactNode;
}

const cls = (variant: Variant, size: Size, extra?: string) => ["btn", `btn--${variant}`, `btn--${size}`, extra].filter(Boolean).join(" ");

export const Button = forwardRef<HTMLButtonElement, Common & ButtonHTMLAttributes<HTMLButtonElement>>(function Button(
  { variant = "secondary", size = "md", icon, iconEnd, busy, children, className, type = "button", disabled, ...rest },
  ref,
) {
  return (
    <button ref={ref} type={type} className={cls(variant, size, className)} disabled={disabled || busy} aria-busy={busy || undefined} {...rest}>
      {busy ? <span className="spinner" aria-hidden /> : icon ? <Icon name={icon} size={size === "sm" ? 16 : 20} /> : null}
      {children && <span>{children}</span>}
      {iconEnd && <Icon name={iconEnd} size={size === "sm" ? 16 : 20} />}
    </button>
  );
});

export function LinkButton({ variant = "secondary", size = "md", icon, iconEnd, children, className, ...rest }: Common & LinkProps) {
  return (
    <Link className={cls(variant, size, className)} {...rest}>
      {icon && <Icon name={icon} size={size === "sm" ? 16 : 20} />}
      {children && <span>{children}</span>}
      {iconEnd && <Icon name={iconEnd} size={size === "sm" ? 16 : 20} />}
    </Link>
  );
}
